import { BaseEntityModel } from '../core/abstractions/base-entity.model';

export class SimpleItemModel extends BaseEntityModel {
    label: string;

    constructor(init: SimpleItemModel) {
        super();
        Object.assign(this, init);
    }
}
